import { Injectable } from '@angular/core';
import {BaseService} from '../../base.service';

@Injectable({
  providedIn: 'root'
})
export class AgentService extends BaseService  {

  getAgency(params?: any) {
    return this.get<any>('/agency', {params});
  }

  getAgencyExport(params?: any) {
    const httpOptions = {
      params,
      responseType: 'blob',
    };
    return this.get<any>('/agency/export', httpOptions);
  }

  changeAgentStatus(body) {
    return this.post<any>('/agency/status', body);
  }
}
